import { IconButton, TextField } from '@mui/material';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import ClearIcon from '@mui/icons-material/Clear';

/** The search box used on every list screen: magnifier on the left, clear on the right. */
const SearchField = ({
  value,
  onChange,
  placeholder = 'Search...',
  width = 320,
  autoFocus = false,
}: {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  width?: number | string;
  autoFocus?: boolean;
}) => (
  <TextField
    placeholder={placeholder}
    size="small"
    autoFocus={autoFocus}
    value={value}
    onChange={(event) => onChange(event.target.value)}
    sx={{ width }}
    InputProps={{
      startAdornment: (
        <IconButton edge="start" size="small" tabIndex={-1} disableRipple>
          <SearchOutlinedIcon sx={{ color: 'text.disabled' }} fontSize="small" />
        </IconButton>
      ),
      endAdornment: value ? (
        <IconButton edge="end" size="small" tabIndex={-1} onClick={() => onChange('')} aria-label="Clear">
          <ClearIcon fontSize="small" />
        </IconButton>
      ) : null,
    }}
  />
);

export default SearchField;
